import { z } from 'zod'

const TemplateInstallationSchema = z.object({
  installation_date: z.number(),
  status: z.string(),
  template_installation_id: z.number(),
  is_trackable: z.boolean(),
  page_name: z.string(),
  page_id: z.number(),
  avatar: z.string().nullable(),
  is_pro: z.boolean(),
  is_ai_addon: z.boolean().optional(),
})

const TemplateInstallationResponseSchema = z.object({
  templates: z.array(TemplateInstallationSchema),
  template_installations_count: z.number(),
  limiter: z.number().nullish(),
})

export const templateInstallationSchemas = {
  fetch: {
    path: z.undefined(),
    query: z.object({
      template_id: z.number(),
      limit: z.number().optional(),
      q: z.string().optional(),
    }),
    request: z.undefined(),
    response: TemplateInstallationResponseSchema,
  },
  enableTemplateForPage: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({
      page_id: z.number(),
      template_installation_id: z.number(),
    }),
    response: z.object({
      page_id: z.number(),
    }),
  },
  disableTemplateForPage: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({
      page_id: z.number(),
      template_installation_id: z.number(),
    }),
    response: z.object({
      page_id: z.number(),
    }),
  },
}
export type TemplateInstallation = z.infer<typeof TemplateInstallationSchema>
